module.exports = require('./src/config/gatsby-browser')
